import { render } from "./CourseCard.vue?vue&type=template&id=2ccd56cd&scoped=true&ts=true"
import script from "./CourseCard.vue?vue&type=script&lang=ts"
export * from "./CourseCard.vue?vue&type=script&lang=ts"

import "./CourseCard.vue?vue&type=style&index=0&id=2ccd56cd&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccd56cd"]])

export default __exports__